import {IText} from "../../interface";

export const AdditionalInfoPageText: IText = {
    backButton: "Вернуться назад",
    title: "Дополнительная информация",

    startCooperation: "Начать сотрудничество",

    registryInfoTitle: "Информация о включении в реестр ПО:",
    registryInfoText:
        "Система DECK AIR внесена в Единый реестр российских программ для электронных вычислительных машин и баз данных. Реестровая запись",
    registryNumber: "№7453\u00A0от\u00A030.11.2020",

    rightsInfoTitle: "Информация об исключительных правах:",
    rightsInfoText:
        "Правообладателем системы DECK AIR является ООО «ДЕКА» (Свидетельство о регистрации №2019664087, дата регистрации 30.10.2019г.).",

    costTitle: "Стоимость:",
    costText1:
        "Права использования программного обеспечения предоставляются на основании возмездного лицензионного договора.",
    costText2:
        "В соответствии с Федеральным законом «О коммерческой тайне» от 29.07.2004г. № 98-ФЗ в отношении стоимости лицензий установлен режим  коммерческой тайны.",
    costText3:
        "Стоимость рассчитывается индивидуально для каждого Заказчика в зависимости от необходимого функционала и пассажиропотока аэропорта.",
    costText4:
        "Для детального расчета стоимости направьте заявку в",
    feedbackForm: "форме\u00A0обратной\u00A0связи",
    costText5: "или на электронную почту projects@deck.lc.",

    techStackTitle: "Стек технологий:",
    techPhp: "PHP",
    techGo: "Go",
    techReact: "React",
    techPostgresql: "PostgreSQL",

    documentationTitle: "Документация:",
    functionalDescription: "Описание функциональных характеристик",
    userManual: "Руководство пользователя",
    installationGuide: "Инструкция по установке",

    menuOpen: "Меню",
    menuClose: "Закрыть",
};
